export class EfficiencyMetricParent {
  constructor() {
    this.list = []
  }

  addEfficiencyMetric(item) {
    this.list.push(EfficiencyMetric.buildFromAPI(item))
  }

  updateEfficiencyMetric(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, EfficiencyMetric.buildFromAPI(item))
  }

  removeEfficiencyMetric(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => EfficiencyMetric.buildFromAPI(el))
    }
    return this
  }
}

export class EfficiencyMetric {
  constructor() {
    this.id = null
    this.codePE = null
    this.name = null
    this.activity = null
  }

  getForAPI() {
    return {
      id: this.id,
      codePE: this.codePE,
      name: this.name,
      activity: this.activity
    }
  }

  static buildFromAPI(obj) {
    const _this = new EfficiencyMetric()
    if (obj) {
      _this.id = obj.id
      _this.codePE = obj.codePE
      _this.name = obj.name
      _this.activity = obj.activity
    }
    return _this
  }
}
